import 'altcha';
import { register } from './auth-api';
import { API_BASE } from '../network/api';

const devUsername = import.meta.env.DEV ? 'admin' : '';
const devEmail = import.meta.env.DEV ? 'admin@tactus.dev' : '';
const devPassword = import.meta.env.DEV ? 'tactus123' : '';

export function renderRegister(root: HTMLElement, onSuccess: () => void): () => void {
  root.innerHTML = `
    <div class="min-h-screen grid place-items-center px-5 py-10 bg-auth-gradient">
      <form class="w-full max-w-[420px] bg-auth-card border border-border rounded-lg p-8 shadow-lift" id="register-form" novalidate>
        <h1 class="mb-2 font-heading text-2xl text-gold tracking-wide">Create an account</h1>
        <p class="mb-6 text-sm text-text-dim">It takes less than a minute.</p>
        <div id="register-error" class="mb-3.5 px-3 py-2.5 bg-error/[0.08] border border-error/40 rounded text-error text-[13px]" hidden></div>
        <label class="block mb-3.5">
          <span class="block mb-1.5 text-[13px] text-text-dim">Username</span>
          <input type="text" name="username" minlength="3" maxlength="32" pattern="[a-zA-Z0-9_-]+" value="${devUsername}"
            class="w-full px-3 py-2.5 bg-surface text-text border border-border rounded outline-none transition-colors duration-[120ms] focus:border-gold focus:shadow-glow" />
        </label>
        <label class="block mb-3.5">
          <span class="block mb-1.5 text-[13px] text-text-dim">Email</span>
          <input type="email" name="email" autocomplete="email" required value="${devEmail}"
            class="w-full px-3 py-2.5 bg-surface text-text border border-border rounded outline-none transition-colors duration-[120ms] focus:border-gold focus:shadow-glow" />
        </label>
        <label class="block mb-3.5">
          <span class="block mb-1.5 text-[13px] text-text-dim">Password (min 8 chars)</span>
          <input type="password" name="password" autocomplete="new-password" minlength="8" required value="${devPassword}"
            class="w-full px-3 py-2.5 bg-surface text-text border border-border rounded outline-none transition-colors duration-[120ms] focus:border-gold focus:shadow-glow" />
        </label>
        <div class="mb-3.5">
          <altcha-widget challenge="${API_BASE}/auth/altcha-challenge" auto="onload" name="altcha"></altcha-widget>
        </div>
        <button type="submit" class="inline-block w-full p-3 bg-gold text-bg font-bold border-0 rounded transition-colors duration-[120ms] hover:bg-gold-bright disabled:bg-border disabled:text-text-dim disabled:cursor-not-allowed" id="register-btn">Create account</button>
        <p class="mt-5 text-[13px] text-text-dim text-center">
          Have an account? <a href="/login">Sign in</a>
        </p>
      </form>
    </div>
  `;

  const form = root.querySelector('#register-form') as HTMLFormElement;
  const errEl = root.querySelector('#register-error') as HTMLDivElement;
  const btn = root.querySelector('#register-btn') as HTMLButtonElement;

  const handler = async (e: Event) => {
    e.preventDefault();
    errEl.hidden = true;
    const fd = new FormData(form);
    const altchaPayload = fd.get('altcha') as string | null;
    if (!altchaPayload) {
      errEl.textContent = 'Please wait for verification to complete.';
      errEl.hidden = false;
      return;
    }
    btn.disabled = true;
    btn.textContent = 'Creating…';
    try {
      await register(
        String(fd.get('email') ?? ''),
        String(fd.get('password') ?? ''),
        altchaPayload,
        (fd.get('username') || undefined) as string | undefined,
      );
      onSuccess();
    } catch (err) {
      errEl.textContent = (err as Error).message;
      errEl.hidden = false;
      btn.disabled = false;
      btn.textContent = 'Create account';
    }
  };
  form.addEventListener('submit', handler);
  return () => form.removeEventListener('submit', handler);
}
